/* eslint-disable @typescript-eslint/no-explicit-any */
import { routerAdvertisingList, routerBusinessList } from '@/mock/index';
import { getUserInfo } from '@/request/https/login';
import router from '@/router/index';

const defAdvertisingPathList = [
    '/dataBoard',
    '/dataBoard/blocData',
    '/dataBoard/adData',
    '/dataBoard/projectData',
    '/dataBoard/mediumData',
    '/dataBoard/daiOrdersData',
    '/dataBoard/redBroker',
    '/dataBoard/redBusiness',
    '/dataBoard/rouWen',
    '/dataBoard/pitcher',
    '/financialManage/historyReplenish',

    '/advertisingTracking',
    '/advertisingTracking/receivablesForecast',
    '/advertisingTracking/receivablesTracking_project',
    '/advertisingTracking/receivablesTracking',
    '/advertisingTracking/contractForecast',
    '/advertisingTracking/expenditureForecast',
    '/advertisingTracking/returnForecast',

    '/staffManage',
    '/staffManage/staffList',
    '/staffManage/dimission',
    '/staffManage/dimission/dimissionDetails'
];

const defAdvertisingTracking = [
    '/advertisingTracking',
    '/advertisingTracking/receivablesTracking_project',
    '/advertisingTracking/receivablesTracking',
    '/advertisingTracking/contractForecast',
    '/advertisingTracking/expenditureForecast'
];

const defBusinessPathList = [
    '/business',
    '/business/cstomer'
];

const defStaffManagePathList = [
    '/staffManage',
    '/staffManage/staffList',
    '/staffManage/dimission',
    '/staffManage/dimission/dimissionDetails'
];

/**
 * @function 你的动态路由数组（可换成接口）
 * @returns 
 */
const getDynamicRoutes = async () => {
    const res: any = await getUserInfo({});
    if (res.code == 0) {
        localStorage.setItem('user_info', JSON.stringify(res.data));
        const isCaiwu = res.data.isCaiwu;
        const biIdentity = res.data.biIdentity;
        const deptIdentity = res.data.deptIdentity;
        const isDeptLeader = res.data.isDeptLeader;
        const identity = localStorage.getItem('user_login_identity');
        if (identity == 'cx') {
            let advertisingTrackingList: any = [];
            if (isCaiwu || biIdentity == 'boss' || deptIdentity == 'ad_sw' || [1, 2, 3, 4].includes(res.data.id)) advertisingTrackingList = [
                ...defAdvertisingTracking,
                '/advertisingTracking/receivablesForecast'
            ];
            else if (deptIdentity == 'xm' && isDeptLeader) advertisingTrackingList = defAdvertisingTracking;

            if ([1, 2, 3, 4, 5, 133].includes(res.data.id) && advertisingTrackingList.length > 0 || isCaiwu && advertisingTrackingList.length > 0) advertisingTrackingList = [
                ...advertisingTrackingList,
                '/advertisingTracking/returnForecast'
            ];
            else if ([1, 2, 3, 4, 5, 133].includes(res.data.id) || isCaiwu) advertisingTrackingList = [
                '/advertisingTracking',
                '/advertisingTracking/returnForecast'
            ];

            if(res.data.id <= 4) advertisingTrackingList = [
                ...advertisingTrackingList,
                ...defStaffManagePathList
            ];

            const biPathList = res.data.biPathList || [];
            const routePathList = res.data.routePathList || [];
            const pathList = res.data.biPathList ? [
                ...biPathList,
                ...routePathList,
                ...advertisingTrackingList,
                '/dataBoard'
            ] : routePathList;

            const menuDataList = await routerAdvertisingList.filter((item_1) => {
                if (item_1.children.length > 0) item_1.children = item_1.children.filter((item_2) => {
                    if (item_2.children.length > 0) item_2.children = item_2.children.filter((item_3) => {
                        if (pathList.includes(item_3.path)) return item_3;
                        else if (!defAdvertisingPathList.includes(item_3.path)) return item_3;
                    });
                    if (pathList.includes(item_2.path)) return item_2;
                    else if (!defAdvertisingPathList.includes(item_2.path)) return item_2;
                });
                if (pathList.includes(item_1.path)) return item_1;
                else if (!defAdvertisingPathList.includes(item_1.path)) return item_1;
            });
            return menuDataList;
        } else if (identity == 'land') {
            const pathList = defBusinessPathList;
            const menuDataList = await routerBusinessList.filter((item_1) => {
                if (item_1.children.length > 0) item_1.children = item_1.children.filter((item_2) => {
                    if (pathList.includes(item_2.path)) return item_2;
                    else if (!defBusinessPathList.includes(item_2.path)) return item_2;
                });
                if (pathList.includes(item_1.path)) return item_1;
                else if (!defBusinessPathList.includes(item_1.path)) return item_1;
            });
            return menuDataList;
        } else return [];
    } else return [];
};

/**
 * @function 全局路由守卫：所有跳转都会走这里（核心）
 * @param data 
 * @returns 
 */
export const setDynamicRoutes = async () => {
    // 判断首页路由是否存在
    const href = location.href;
    const pathname = location.pathname;
    const query = href.split(pathname)[1];
    const hasDynamicRoute = router.getRoutes().some(route => {
        return route.path === pathname;
    });
    if (!hasDynamicRoute) {
        try {
            // 加载动态路由
            const dynamicRoutes = await getDynamicRoutes()
            // 批量注册路由数组
            await dynamicRoutes.forEach((route: any) => {
                router.addRoute(route)
            });
            const isRouteExist = await router.getRoutes().some(route => {
                return route.path === pathname;
            });
            if (isRouteExist) router.push(`${pathname}${query}`);
            else router.push('/404');
            localStorage.removeItem('router_data_list');
            localStorage.setItem('router_data_list', JSON.stringify(dynamicRoutes));
        } catch (err) {
            console.log(err)
        }
    }
};

/**
 * @function 你的动态路由数组（可换成接口）
 * @returns 
 */
export const getDynamicRoutesData = async () => {
    const dynamicRoutes: any = await getDynamicRoutes();
    return dynamicRoutes;
};